import { render, staticRenderFns } from "./BookmakersCreate.vue?vue&type=template&id=9225fafe&"
import script from "./BookmakersCreate.vue?vue&type=script&lang=ts&"
export * from "./BookmakersCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports